// extracted by mini-css-extract-plugin
module.exports = {"text":"OrganizationChartWarningModal_text__24YdW","fetchButton":"OrganizationChartWarningModal_fetchButton__2pFe-"};